/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

import FileChecks from './file.js'
import RequestChecks from './request.js'

export default [...FileChecks, ...RequestChecks]
